var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',_vm._g(_vm._b({staticClass:"dotcom-icon",style:(_vm.cssProps),attrs:{"icon":[_vm.iconArt, _vm.iconName]}},'font-awesome-icon',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }